<template>
	<div class="slider" :style="fundoSlider">
		<land-page-header :backgroundTransparent="true" />
		<land-page-search />
		<div>
			<land-page-totals v-if="!parceiro || parceiro === 'acerte_aqui'" />
		</div>
	</div>
</template>

<script>
import LandPageHeader from "./LandPageHeader"
import LandPageSearch from "./LandPageSearch"
import LandPageTotals from "./LandPageTotals"
import { mapState } from "vuex"
export default {
	name: "LandPageSlider",
	components: { LandPageTotals, LandPageSearch, LandPageHeader },
	computed: {
		...mapState({
			parceiro: state => state.parceiro,
			parceiroConfig: state => state.parceiroConfig,
			corPrimaria: state => state.corPrimaria,
			corSecundaria: state => state.corSecundaria
		}),
		fundoSlider: function() {
			return {
				"--fundoFull": "url(" + require(`../../../assets/images/background.png`) + ")",
				"--fundo768": "url(" + require(`../../../assets/images/background.png`) + ")",
				"--fundo500": "url(" + require(`../../../assets/images/background.png`) + ")"
			}
		}
	}
}
</script>

<style scoped lang="scss">
.slider {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;

	/* Set a specific height */
	min-height: 500px;

	/* Create the parallax scrolling effect */
	background-image: var(--fundoFull);
	background-size: 100% 100%;
	background-attachment: fixed;
	background-position: center;
	background-repeat: no-repeat;
	@media only screen and (max-width: 1024px) {
		background-image: var(--fundo768);
		background-size: cover;
		background-attachment: initial;
	}
	@media only screen and (max-width: 500px) {
		background-image: var(--fundo500);
		background-size: cover;
		background-attachment: initial;
	}
}
</style>
